import { gql } from '@apollo/client';

export const ChangePhoneNumberWhileRegistration = gql`
    mutation changePhoneNumberWhileRegistration($email: String!, $phoneNumber: String!) {
        changePhoneNumberWhileRegistration(email: $email, phoneNumber: $phoneNumber) {
            ... on SuccessType {
                message
            }

            ... on ErrorType {
                message
            }
        }
    }
`;
